import { Link } from "react-router-dom";
import { categories } from "@/mocks/clips";

export default function Footer() {
  return (
    <footer className="mt-20 bg-secondary-950 text-secondary-50">
      <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-live-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold">爆料现场</span>
            </div>
            <p className="font-body text-sm leading-relaxed text-secondary-100/80">
              整理爆料直播中的高能片段，主播关键发言一字不漏，弹幕热议与直播内容文字版随时可查。错过直播，也不会错过现场。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="font-heading text-sm font-bold text-accent-300">
              <Link to="/clips">热门分类</Link>
            </h4>
            <ul className="flex flex-col gap-2 font-body text-sm text-secondary-100/80">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/clips?cat=${cat.id}`}
                    className="transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="font-heading text-sm font-bold text-accent-300">站内导航</h4>
            <ul className="flex flex-col gap-2 font-body text-sm text-secondary-100/80">
              <li><Link to="/" className="transition-colors hover:text-accent-300">首页</Link></li>
              <li><Link to="/clips" className="transition-colors hover:text-accent-300">爆料片段库</Link></li>
              <li><Link to="/clips?sort=hot" className="transition-colors hover:text-accent-300">今日高能榜</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-accent-300">关于我们</Link></li>
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="font-heading text-sm font-bold text-accent-300">线索与联系</h4>
            <p className="font-body text-sm text-secondary-100/80">
              发现值得收录的爆料片段？把场次和时间点发给我们。
            </p>
            <a
              href="mailto:clip@baoliaoxianchang.com"
              rel="nofollow"
              className="inline-flex w-fit items-center gap-2 rounded-md border border-secondary-200/40 px-3 py-2 text-sm font-label text-secondary-50 transition-colors hover:border-accent-300 hover:text-accent-300"
            >
              <i className="ri-mail-send-line" />
              clip@baoliaoxianchang.com
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200/20 pt-6 font-label text-xs text-secondary-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 爆料现场 · 本站内容为公开直播片段的整理与索引</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-300">内容原则</Link>
            <Link to="/about" className="transition-colors hover:text-accent-300">联系我们</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}